import { CustomError } from 'ts-custom-error'
import { type GraphQLError } from 'graphql'

class GraphQLAggregateError extends CustomError {
  errors: ReadonlyArray<GraphQLError>

  constructor(errors: ReadonlyArray<GraphQLError>) {
    super(errors.map(({ message }) => message).join('\n'))
    this.errors = errors
  }
}

export default GraphQLAggregateError
